import { Roles } from "../../constants/roles";
import { FormBase } from "../../util/form-base-form";

class SNSPostForm extends FormBase {
    public getClosestLinkInput(root: Event | EventTarget | Element | null | undefined): HTMLElement | null {
        return this.closest(root, `[data-role="${Roles.SNS_LINK_INPUT}"]`, HTMLElement);
    }

    public getClosestPreviewTile(root: Event | EventTarget | Element | null | undefined): HTMLElement | null {
        return this.closest(root, `[data-role="${Roles.SNS_PREVIEW_TILE}"]`, HTMLElement);
    }

    public getClosestRemoveButton(root: Event | EventTarget | Element | null | undefined): HTMLElement | null {
        return this.closest(root, `[data-role="${Roles.SNS_TILE_REMOVE}"]`, HTMLElement);
    }
}

const snsPostForm = new SNSPostForm();

export { snsPostForm };
